/**
 * Get the display name for a user, preferring displayName over firstName/lastName
 * @param user - User object with optional displayName, firstName, and lastName
 * @returns The user's display name
 */
export const getUserDisplayName = (user: {
  displayName?: string | null;
  firstName?: string;
  lastName?: string;
}): string => {
  // Prefer displayName if available
  if (user.displayName && user.displayName.trim()) {
    return user.displayName.trim();
  }
  
  // Fallback to firstName + lastName
  const firstName = user.firstName?.trim() || '';
  const lastName = user.lastName?.trim() || '';
  
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  
  if (firstName) {
    return firstName;
  }
  
  if (lastName) {
    return lastName;
  }
  
  // Last resort
  return 'User';
};

/**
 * Get the short display name for a user (just first name or displayName)
 * @param user - User object with optional displayName and firstName
 * @returns The user's short display name
 */
export const getUserShortDisplayName = (user: {
  displayName?: string | null;
  firstName?: string;
}): string => {
  // Prefer displayName if available
  if (user.displayName && user.displayName.trim()) {
    return user.displayName.trim();
  }
  
  // Fallback to firstName
  return user.firstName?.trim() || 'User';
};
